"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateMarketLiquidityUsageMultiplierEvent = exports.WithdrawFromPoolEvent = exports.DepositToPoolEvent = exports.SetMarketConfigEvent = exports.DeregisterFromPoolEvent = exports.RegisterToPoolEvent = exports.PoolEvent = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const pool_1 = require("./pool");
const market_1 = require("./market");
exports.protobufPackage = "Switcheo.carbon.perpspool";
const basePoolEvent = { type: "" };
exports.PoolEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pool !== undefined) {
            pool_1.Pool.encode(message.pool, writer.uint32(10).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(18).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, basePoolEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pool = pool_1.Pool.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, basePoolEvent);
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? pool_1.Pool.fromJSON(object.pool)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pool !== undefined &&
            (obj.pool = message.pool ? pool_1.Pool.toJSON(message.pool) : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, basePoolEvent);
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? pool_1.Pool.fromPartial(object.pool)
                : undefined;
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseRegisterToPoolEvent = { poolId: long_1.default.UZERO, marketId: "" };
exports.RegisterToPoolEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.marketId !== "") {
            writer.uint32(18).string(message.marketId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRegisterToPoolEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.marketId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRegisterToPoolEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.marketId !== undefined && (obj.marketId = message.marketId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseRegisterToPoolEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.marketId = (_a = object.marketId) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseDeregisterFromPoolEvent = {
    poolId: long_1.default.UZERO,
    marketId: "",
};
exports.DeregisterFromPoolEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.marketId !== "") {
            writer.uint32(18).string(message.marketId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDeregisterFromPoolEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.marketId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDeregisterFromPoolEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.marketId !== undefined && (obj.marketId = message.marketId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseDeregisterFromPoolEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.marketId = (_a = object.marketId) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseSetMarketConfigEvent = {};
exports.SetMarketConfigEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.marketConfig !== undefined) {
            market_1.MarketConfig.encode(message.marketConfig, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetMarketConfigEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.marketConfig = market_1.MarketConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetMarketConfigEvent);
        message.marketConfig =
            object.marketConfig !== undefined && object.marketConfig !== null
                ? market_1.MarketConfig.fromJSON(object.marketConfig)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.marketConfig !== undefined &&
            (obj.marketConfig = message.marketConfig
                ? market_1.MarketConfig.toJSON(message.marketConfig)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSetMarketConfigEvent);
        message.marketConfig =
            object.marketConfig !== undefined && object.marketConfig !== null
                ? market_1.MarketConfig.fromPartial(object.marketConfig)
                : undefined;
        return message;
    },
};
const baseDepositToPoolEvent = {
    poolId: long_1.default.UZERO,
    denom: "",
    amount: "",
    shareDenom: "",
    shareAmount: "",
    initialShareAmountBurnt: "",
    depositor: "",
    feeToPoolDenom: "",
    feeToPoolAmount: "",
    feeToPoolCommissionDenom: "",
    feeToPoolCommissionAmount: "",
};
exports.DepositToPoolEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        if (message.shareDenom !== "") {
            writer.uint32(34).string(message.shareDenom);
        }
        if (message.shareAmount !== "") {
            writer.uint32(42).string(message.shareAmount);
        }
        if (message.initialShareAmountBurnt !== "") {
            writer.uint32(50).string(message.initialShareAmountBurnt);
        }
        if (message.depositor !== "") {
            writer.uint32(58).string(message.depositor);
        }
        if (message.feeToPoolDenom !== "") {
            writer.uint32(66).string(message.feeToPoolDenom);
        }
        if (message.feeToPoolAmount !== "") {
            writer.uint32(74).string(message.feeToPoolAmount);
        }
        if (message.feeToPoolCommissionDenom !== "") {
            writer.uint32(82).string(message.feeToPoolCommissionDenom);
        }
        if (message.feeToPoolCommissionAmount !== "") {
            writer.uint32(90).string(message.feeToPoolCommissionAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDepositToPoolEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                case 4:
                    message.shareDenom = reader.string();
                    break;
                case 5:
                    message.shareAmount = reader.string();
                    break;
                case 6:
                    message.initialShareAmountBurnt = reader.string();
                    break;
                case 7:
                    message.depositor = reader.string();
                    break;
                case 8:
                    message.feeToPoolDenom = reader.string();
                    break;
                case 9:
                    message.feeToPoolAmount = reader.string();
                    break;
                case 10:
                    message.feeToPoolCommissionDenom = reader.string();
                    break;
                case 11:
                    message.feeToPoolCommissionAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDepositToPoolEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        message.shareDenom =
            object.shareDenom !== undefined && object.shareDenom !== null
                ? String(object.shareDenom)
                : "";
        message.shareAmount =
            object.shareAmount !== undefined && object.shareAmount !== null
                ? String(object.shareAmount)
                : "";
        message.initialShareAmountBurnt =
            object.initialShareAmountBurnt !== undefined &&
                object.initialShareAmountBurnt !== null
                ? String(object.initialShareAmountBurnt)
                : "";
        message.depositor =
            object.depositor !== undefined && object.depositor !== null
                ? String(object.depositor)
                : "";
        message.feeToPoolDenom =
            object.feeToPoolDenom !== undefined && object.feeToPoolDenom !== null
                ? String(object.feeToPoolDenom)
                : "";
        message.feeToPoolAmount =
            object.feeToPoolAmount !== undefined && object.feeToPoolAmount !== null
                ? String(object.feeToPoolAmount)
                : "";
        message.feeToPoolCommissionDenom =
            object.feeToPoolCommissionDenom !== undefined &&
                object.feeToPoolCommissionDenom !== null
                ? String(object.feeToPoolCommissionDenom)
                : "";
        message.feeToPoolCommissionAmount =
            object.feeToPoolCommissionAmount !== undefined &&
                object.feeToPoolCommissionAmount !== null
                ? String(object.feeToPoolCommissionAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        message.shareDenom !== undefined && (obj.shareDenom = message.shareDenom);
        message.shareAmount !== undefined &&
            (obj.shareAmount = message.shareAmount);
        message.initialShareAmountBurnt !== undefined &&
            (obj.initialShareAmountBurnt = message.initialShareAmountBurnt);
        message.depositor !== undefined && (obj.depositor = message.depositor);
        message.feeToPoolDenom !== undefined &&
            (obj.feeToPoolDenom = message.feeToPoolDenom);
        message.feeToPoolAmount !== undefined &&
            (obj.feeToPoolAmount = message.feeToPoolAmount);
        message.feeToPoolCommissionDenom !== undefined &&
            (obj.feeToPoolCommissionDenom = message.feeToPoolCommissionDenom);
        message.feeToPoolCommissionAmount !== undefined &&
            (obj.feeToPoolCommissionAmount = message.feeToPoolCommissionAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const message = Object.assign({}, baseDepositToPoolEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        message.shareDenom = (_c = object.shareDenom) !== null && _c !== void 0 ? _c : "";
        message.shareAmount = (_d = object.shareAmount) !== null && _d !== void 0 ? _d : "";
        message.initialShareAmountBurnt = (_e = object.initialShareAmountBurnt) !== null && _e !== void 0 ? _e : "";
        message.depositor = (_f = object.depositor) !== null && _f !== void 0 ? _f : "";
        message.feeToPoolDenom = (_g = object.feeToPoolDenom) !== null && _g !== void 0 ? _g : "";
        message.feeToPoolAmount = (_h = object.feeToPoolAmount) !== null && _h !== void 0 ? _h : "";
        message.feeToPoolCommissionDenom = (_j = object.feeToPoolCommissionDenom) !== null && _j !== void 0 ? _j : "";
        message.feeToPoolCommissionAmount = (_k = object.feeToPoolCommissionAmount) !== null && _k !== void 0 ? _k : "";
        return message;
    },
};
const baseWithdrawFromPoolEvent = {
    poolId: long_1.default.UZERO,
    denom: "",
    amount: "",
    shareDenom: "",
    shareAmount: "",
    withdrawer: "",
    feeToPoolDenom: "",
    feeToPoolAmount: "",
    feeToCommissionDenom: "",
    feeToCommissionAmount: "",
};
exports.WithdrawFromPoolEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        if (message.shareDenom !== "") {
            writer.uint32(34).string(message.shareDenom);
        }
        if (message.shareAmount !== "") {
            writer.uint32(42).string(message.shareAmount);
        }
        if (message.withdrawer !== "") {
            writer.uint32(50).string(message.withdrawer);
        }
        if (message.feeToPoolDenom !== "") {
            writer.uint32(58).string(message.feeToPoolDenom);
        }
        if (message.feeToPoolAmount !== "") {
            writer.uint32(66).string(message.feeToPoolAmount);
        }
        if (message.feeToCommissionDenom !== "") {
            writer.uint32(74).string(message.feeToCommissionDenom);
        }
        if (message.feeToCommissionAmount !== "") {
            writer.uint32(82).string(message.feeToCommissionAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseWithdrawFromPoolEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                case 4:
                    message.shareDenom = reader.string();
                    break;
                case 5:
                    message.shareAmount = reader.string();
                    break;
                case 6:
                    message.withdrawer = reader.string();
                    break;
                case 7:
                    message.feeToPoolDenom = reader.string();
                    break;
                case 8:
                    message.feeToPoolAmount = reader.string();
                    break;
                case 9:
                    message.feeToCommissionDenom = reader.string();
                    break;
                case 10:
                    message.feeToCommissionAmount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseWithdrawFromPoolEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        message.shareDenom =
            object.shareDenom !== undefined && object.shareDenom !== null
                ? String(object.shareDenom)
                : "";
        message.shareAmount =
            object.shareAmount !== undefined && object.shareAmount !== null
                ? String(object.shareAmount)
                : "";
        message.withdrawer =
            object.withdrawer !== undefined && object.withdrawer !== null
                ? String(object.withdrawer)
                : "";
        message.feeToPoolDenom =
            object.feeToPoolDenom !== undefined && object.feeToPoolDenom !== null
                ? String(object.feeToPoolDenom)
                : "";
        message.feeToPoolAmount =
            object.feeToPoolAmount !== undefined && object.feeToPoolAmount !== null
                ? String(object.feeToPoolAmount)
                : "";
        message.feeToCommissionDenom =
            object.feeToCommissionDenom !== undefined &&
                object.feeToCommissionDenom !== null
                ? String(object.feeToCommissionDenom)
                : "";
        message.feeToCommissionAmount =
            object.feeToCommissionAmount !== undefined &&
                object.feeToCommissionAmount !== null
                ? String(object.feeToCommissionAmount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        message.shareDenom !== undefined && (obj.shareDenom = message.shareDenom);
        message.shareAmount !== undefined &&
            (obj.shareAmount = message.shareAmount);
        message.withdrawer !== undefined && (obj.withdrawer = message.withdrawer);
        message.feeToPoolDenom !== undefined &&
            (obj.feeToPoolDenom = message.feeToPoolDenom);
        message.feeToPoolAmount !== undefined &&
            (obj.feeToPoolAmount = message.feeToPoolAmount);
        message.feeToCommissionDenom !== undefined &&
            (obj.feeToCommissionDenom = message.feeToCommissionDenom);
        message.feeToCommissionAmount !== undefined &&
            (obj.feeToCommissionAmount = message.feeToCommissionAmount);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const message = Object.assign({}, baseWithdrawFromPoolEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        message.shareDenom = (_c = object.shareDenom) !== null && _c !== void 0 ? _c : "";
        message.shareAmount = (_d = object.shareAmount) !== null && _d !== void 0 ? _d : "";
        message.withdrawer = (_e = object.withdrawer) !== null && _e !== void 0 ? _e : "";
        message.feeToPoolDenom = (_f = object.feeToPoolDenom) !== null && _f !== void 0 ? _f : "";
        message.feeToPoolAmount = (_g = object.feeToPoolAmount) !== null && _g !== void 0 ? _g : "";
        message.feeToCommissionDenom = (_h = object.feeToCommissionDenom) !== null && _h !== void 0 ? _h : "";
        message.feeToCommissionAmount = (_j = object.feeToCommissionAmount) !== null && _j !== void 0 ? _j : "";
        return message;
    },
};
const baseUpdateMarketLiquidityUsageMultiplierEvent = {
    marketId: "",
    multiplier: "",
};
exports.UpdateMarketLiquidityUsageMultiplierEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.marketId !== "") {
            writer.uint32(10).string(message.marketId);
        }
        if (message.multiplier !== "") {
            writer.uint32(18).string(message.multiplier);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUpdateMarketLiquidityUsageMultiplierEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.marketId = reader.string();
                    break;
                case 2:
                    message.multiplier = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUpdateMarketLiquidityUsageMultiplierEvent);
        message.marketId =
            object.marketId !== undefined && object.marketId !== null
                ? String(object.marketId)
                : "";
        message.multiplier =
            object.multiplier !== undefined && object.multiplier !== null
                ? String(object.multiplier)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.marketId !== undefined && (obj.marketId = message.marketId);
        message.multiplier !== undefined && (obj.multiplier = message.multiplier);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseUpdateMarketLiquidityUsageMultiplierEvent);
        message.marketId = (_a = object.marketId) !== null && _a !== void 0 ? _a : "";
        message.multiplier = (_b = object.multiplier) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
